import { Component, OnInit } from '@angular/core';
import { SettingsService } from '../../settings/settings.service';

@Component({
    selector: 'app-rating-dialog',
    templateUrl: './rating-dialog.component.html',
    styleUrls: ['./rating-dialog.component.scss'],
    standalone: false
})
export class RatingDialogComponent implements OnInit {

  constructor(public readonly settingsService: SettingsService) {
  }

  ngOnInit(): void {
  }

}
